<template>
    <a href="#" @click="logout">
        <i class="pi pi-power-off"></i>
        <h6>Logout</h6>
    </a>
</template>

<script>
export default {
    name: 'Logout',
    methods: {
        logout() {
            this.$store.dispatch('auth/logout');
            this.$router.push('/login');
        },
    },
};
</script>